import { ICareTeamAssignmentPreview } from '@liquid-state/pephealth-client';

export type FetchOrganisationUserCareTeamAssignmentPreview = ReturnType<
  typeof fetchOrganisationUserCareTeamAssignmentPreview
>;
export const fetchOrganisationUserCareTeamAssignmentPreview = (
  organisationSlug: string,
  userId: number,
) => ({
  type: 'organisationUserCareTeamPreview/fetch' as const,
  payload: { organisationSlug, userId },
});

export type OrganisationUserCareTeamAssignmentPreviewLoaded = ReturnType<
  typeof organisationUserCareTeamAssignmentPreviewLoaded
>;
export const organisationUserCareTeamAssignmentPreviewLoaded = (
  assignments: ICareTeamAssignmentPreview[],
) => ({
  type: 'organisationUserCareTeamPreview/loaded' as const,
  payload: { assignments },
});

export type OrganisationUserCareTeamAssignmentPreviewFailed = ReturnType<
  typeof organisationUserCareTeamAssignmentPreviewFailed
>;
export const organisationUserCareTeamAssignmentPreviewFailed = () => ({
  type: 'organisationUserCareTeamPreview/failed' as const,
  payload: {},
});

export type ClearOrganisationUserCareTeamAssignmentPreview = ReturnType<
  typeof clearOrganisationUserCareTeamAssignmentPreview
>;
export const clearOrganisationUserCareTeamAssignmentPreview = () => ({
  type: 'organisationUserCareTeamPreview/clear' as const,
  payload: {},
});
